module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAABmJLR0QA6wArAAXiNRA/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QsOEDcjqIVWkwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAADLSURBVBjTjZAxSgNRFEXPm5efzxQh2UGsLAOKC9Al2AzMUnQBcSsyjUvQBQiCpV0WIJNPAsP35+VZJNPn1hfOuVd+V1OqUHFz/bgGGmAJbIDu6+ft+ViOSH8buVu171rX9yLCGHfHhuHj8/v1Qa7adj1dLJ7CbIbGiKjiZljOlN2Ov+32ZQI0IoLGSJjP0RCwUiAlDvs9QDM5OyCqaAhoXQNwUB3Jy+oseUKUgg0DVgpuNpY2FdC5+8khJXLfU1LCcsbdAbrL1l3y0z8AWmtS9kpDJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/enemy_bullet.png
// module id = 76
// module chunks = 0